import React from 'react';

const Leaderboard = () => <div>I am Leaderboard</div>;

export default Leaderboard;
